<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.checkout') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <div class="pa-4 ol-elevation-2 br-8">
              <div class="list-component">
                <div class="list-avatar mr-4">
                  <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="list-image">
                </div>
                <div class="list-content">
                  <div class="list-content-title font-18 font-weight-700 mb-1">
                    {{ $store.state.selected_outlet.name }}
                  </div>
                  <div v-if="$store.state.selected_type === 'DINE-IN'">
                    <div class="d-flex">
                      <div class="wrap-table">
                        <div class="wrap-table-icon">
                          <img :src="icon_table" :alt="$t('table')">
                        </div>
                        <div class="wrap-table-content">
                          <div class="wrap-table-text">
                            {{ $t('table') }} {{ noTable }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="$store.state.selected_type === 'OL-TAKE-AWAY'">
                    <div class="d-flex">
                      <div class="wrap-table">
                        <div class="wrap-table-icon">
                          <img :src="icon_take_away" :alt="$t('v2.takeaway')">
                        </div>
                        <div class="wrap-table-content">
                          <div class="wrap-table-text">
                            {{ $t('v2.takeaway') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="$store.state.selected_type === 'DELIVERY'">
                    <div class="d-flex">
                      <div class="wrap-table">
                        <div class="wrap-table-icon">
                          <img :src="require('@/assets/images/v2/img/icon-side-delivery.png')" :alt="$t('v2.delivery')">
                        </div>
                        <div class="wrap-table-content">
                          <div class="wrap-table-text">
                            {{ $t('v2.delivery') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <div class="flex-image up-selling-point">
                  <div class="mr-3">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_5089_11439)">
                        <path d="M23.7787 7.11738C24.9911 8.33071 26.7689 8.6356 28.264 8.03471L31.4755 11.2445C32.1307 11.9023 32.1315 12.9672 31.472 13.6267L13.6169 31.4712C12.9564 32.128 11.8924 32.1263 11.2338 31.4712L8.02844 28.2605C8.62577 26.7636 8.32177 24.9876 7.11111 23.7743C5.896 22.5609 4.12089 22.2569 2.62489 22.8569L0.527997 20.7592C-0.129781 20.104 -0.131559 19.0365 0.527997 18.3769L18.3804 0.529821C19.0373 -0.127956 20.1013 -0.128845 20.7618 0.531599L22.8604 2.63027C22.2587 4.12627 22.5662 5.90227 23.7787 7.11738Z" fill="#EA596E" />
                        <path d="M4.81779 16.4685L2.90756 18.3779C2.25067 19.0347 2.2489 20.1014 2.9049 20.7601L3.38667 21.241C5.07201 20.7921 6.94134 21.225 8.25956 22.5459C9.58223 23.8667 10.0116 25.7361 9.56356 27.4179L11.2329 29.0916C11.8916 29.7485 12.9582 29.7485 13.6169 29.0899L15.5627 27.1459L4.81779 16.4685ZM16.8365 25.873L25.8658 16.849L15.1182 6.17164L6.09245 15.1956L16.8365 25.873ZM18.6053 13.4347C20.6009 15.4152 21.0453 18.1956 19.6018 19.6472C18.1556 21.1005 15.3689 20.6703 13.3787 18.6916C11.3885 16.7112 10.9449 13.929 12.3885 12.4774C13.8329 11.0285 16.6151 11.4552 18.6053 13.4347ZM29.0942 11.2445L27.4222 9.57252C25.7378 10.0196 23.8685 9.59119 22.5485 8.26764C21.2258 6.94852 20.792 5.07564 21.2418 3.39297L20.7609 2.90764C20.1031 2.2543 19.0365 2.2543 18.3805 2.9103L16.3929 4.89786L27.1413 15.5743L29.0933 13.6232C29.7511 12.9681 29.7511 11.9023 29.0942 11.2445Z" fill="#BE1931" />
                      </g>
                      <defs>
                        <clipPath id="clip0_5089_11439">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-image-content py-2">
                    <div class="flex-image-content-text font-14 ol-black three-line line-height-19">
                      {{ $t('v2.get_special_bonus_by_redeem_points') }} <span class="font-weight-bold ol-brand cursor-pointer" @click="detailUpSellingPoint">Detail</span>
                    </div>
                  </div>
                  <div class="ml-2 d-flex align-center">
                    <img :src="require('@/assets/images/v2/img/popper_icon.png')" alt="">
                  </div>
                </div>
              </div>
              <template v-if="notSystem && !$isEmpty(customer) && Number(customer.join_loyalty_points) > 0">
                <div v-if="!$isEmpty(cart.point_detail)" class="mt-4">
                  <div class="flex-image px-4 py-2 selected-point">
                    <div class="mr-2">
                      <v-icon size="24" color="primary">
                        mdi-check-circle
                      </v-icon>
                    </div>
                    <div class="flex-image-content">
                      <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                        <template v-if="cart.point_detail.type === 'D'">
                          {{ $t('v2.discount') }}
                          <span v-if="Number(cart.point_detail.discount_amount) === 0">
                            {{ cart.point_detail.discount_rate }}%
                          </span>
                          <span v-else v-mask-money="cart.point_detail.discount_amount" />
                        </template>
                        <template v-else>
                          {{ Number(cart.point_detail.qty) }}x {{ $t('v2.free') }} {{ cart.point_detail.product_name }} {{ cart.point_detail.product_variant_id ? ' - ' + cart.point_detail.product_variant_name : '' }}
                        </template>
                      </div>
                      <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                        {{ $t('v2.exchange_points_for_vouchers') }}
                      </div>
                    </div>
                    <v-btn icon @click="deletePoint()">
                      <v-icon size="20" color="olred">
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div class="div-line mt-4 mb-6" />
                  <div class="flex-image">
                    <div class="flex-image-content">
                      <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                        {{ Number(customer.join_loyalty_points) }} pts
                      </div>
                      <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                        {{ $t('v2.exchange_points_for_vouchers') }}
                      </div>
                    </div>
                    <v-btn color="olbrand" height="40" class="white--text text-none br-5 letter-spacing-normal ol-elevation-1 font-16 font-weight-700" @click="showPoint()">
                      {{ $t('v2.redeem') }}
                    </v-btn>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div v-if="$store.state.selected_type === 'DELIVERY'" class="mt-4">
            <div class="pa-4 ol-elevation-2 br-8">
              <div class="font-18 font-weight-700 mb-4">
                {{ $t('v2.deliveryv2') }}
              </div>
              <div class="mb-4">
                <div class="font-12 ol-black mb-1">
                  {{ $t('v2.delivery_address') }}
                </div>
                <v-text-field v-model="delivery.address" :placeholder="$t('v2.select_delivery_address')" outlined dense height="40" readonly hide-details class="input--button" @click="goToMapsSearch">
                  <template v-slot:prepend-inner>
                    <div class="d-flex">
                      <img src="@/assets/images/v2/img/icon_marker.png" alt="Marker" class="image-20">
                    </div>
                  </template>
                </v-text-field>
              </div>
              <div>
                <div class="font-12 ol-black mb-1">
                  {{ $t('v2.delivery_method') }}
                </div>
                <v-text-field v-model="delivery.delivery_method" :placeholder="$t('v2.select_delivery_method')" outlined dense height="40" readonly hide-details class="input--button" @click="goToDeliveryMethod">
                  <template v-slot:prepend-inner>
                    <div class="d-flex">
                      <img :src="delivery.image" alt="Delivery" class="image-20-width-auto">
                    </div>
                  </template>
                </v-text-field>
              </div>
              <div v-if="nshipping_cost > 0" class="d-flex align-center mt-6">
                <div class="d-flex align-center">
                  <template v-if="shipping.shipping_delivery_type === 1">
                    <div class="d-flex align-center mr-2">
                      <v-tooltip right content-class="la-tooltip" max-width="164">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon size="24" v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="font-14 line-height-normal">
                          {{ $t('v2.delivery_additional_fee_notice', { radius: $store.state.selected_outlet.delivery.radius_free_delivery }) }}
                        </div>
                      </v-tooltip>
                    </div>
                    <div class="font-14 font-weight-400 ol-black">
                      {{ $t('v2.additional_delivery_fee') }}
                    </div>
                  </template>
                  <div v-else class="font-14 font-weight-400 ol-black">
                    {{ $t('v2.delivery_fee') }}
                  </div>
                </div>
                <v-spacer />
                <div v-mask-money="nshipping_cost" class="font-16 ol-black font-weight-600" />
              </div>
            </div>
          </div>
          <template v-if="$store.state.selected_type === 'RESERVATION'">
            <div class="mt-4">
              <div class="pa-4 ol-elevation-2 br-8">
                <div>
                  <div>
                    <div class="d-flex justify-space-between">
                      <div class="">
                        <div class="font-12 font-weight-400 ol-grey-content mb-1">
                          {{ $t('v2.reservation_date') }}
                        </div>
                        <div class="font-18 font-weight-700 ol-black">
                          {{ formatReserveDate }}
                        </div>
                      </div>
                      <div>
                        <div class="font-12 font-weight-400 ol-grey-content mb-1">
                          {{ $t('v2.time') }}
                        </div>
                        <div class="font-18 font-weight-700 ol-black">
                          {{ detail_reservation.reserve_time }}
                        </div>
                      </div>
                      <div>
                        <div class="font-12 font-weight-400 ol-grey-content mb-1">
                          {{ $t('v2.number_of_tables') }}
                        </div>
                        <div class="font-18 font-weight-700 ol-black">
                          {{ detail_reservation.total_guest }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="div-line my-4" />
                  <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 font-16" @click="updateReservation()">
                    {{ $t('v2.change') }}
                  </v-btn>
                </div>
                <div v-if="!detail_reservation || $isEmpty(detail_reservation)" class="flex-image pa-4 br-10 mt-4" style="background-color: #FFF2E3;">
                  <div class="flex-image-avatar mr-4">
                    <v-icon color="#FF931E" size="20">
                      mdi-alert-outline
                    </v-icon>
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-14">
                      {{ $t('v2.date_time_and_number_of_tables') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
              <div class="mt-4">
                <div class="pa-4 ol-elevation-2 br-8">
                  <div class="font-18 font-weight-700 mb-6">
                    {{ $t('v2.transaction_proof') }}
                  </div>
                  <div class="ol-black font-14 font-weight-400 mb-2">
                    {{ $t('v2.we_will_send_proof_of_transaction_via_email') }}
                  </div>
                  <ValidationProvider v-slot="{ errors }" name="email" :rules="{ required: true, email: true }">
                    <v-text-field v-model="detail_reservation.email" :placeholder="$t('v2.your_email_address_here')" outlined dense height="40" :error-messages="errors" class="input--button">
                      <template v-slot:prepend-inner>
                        <div class="d-flex">
                          <img src="@/assets/images/v2/img/icon_email.png" alt="Mail" class="image-20">
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </div>
              </div>
            </ValidationObserver>
          </template>
          <div class="list-item-checkout mt-4">
            <template v-for="(item, idx) in cart.item">
              <!-- if (typeof this.cart.item[i].product_type === 'undefined' || this.cart.item[i].product_type !== 'point') { -->
              <div v-if="item.product_type === 'undefined' || item.product_type !== 'point'" :key="idx" class="container-item-checkout">
                <div class="item-checkout">
                  <div class="item-checkout-qty font-16 font-weight-600 ol-brand mr-2">
                    {{ item.qty }}x
                  </div>
                  <div class="item-checkout-content">
                    <div class="item-checkout-name font-16 font-weight-400 mb-1">
                      {{ item.name }} {{ item.product_variant_name ? '(' + item.product_variant_name + ')' : '' }}
                    </div>
                    <div class="item-checkout-text font-14 font-weight-700 mb-3">
                      <span v-mask-money="item.sub_total" />
                    </div>
                    <div v-if="textAddons(item) !== ''" class="item-checkout-text ol-accent font-12 font-weight-400 mb-1">
                      {{ textAddons(item) }}
                    </div>
                    <div v-if="item.note !== ''" class="item-checkout-text">
                      <div class="d-flex align-center">
                        <div class="mr-1">
                          <v-icon size="18" color="#767676" style="transform: rotate(180deg) scale(-1, 1);">
                            mdi-note-outline
                          </v-icon>
                        </div>
                        <div class="font-12 font-weight 400 ol-grey-content">
                          {{ item.note }}
                        </div>
                      </div>
                    </div>
                    <div :class="['item-checkout-text', { 'mt-3': item.note !== '' || textAddons(item) !== '' }]">
                      <div v-if="item.product_combo_id" class="font-14 ol-brand font-weight-700 cursor-pointer" @click="detailProductCombo(item, idx)">
                        {{ $t('v2.change') }}
                      </div>
                      <div v-else class="font-14 ol-brand font-weight-700 cursor-pointer" @click="detailProduct(item, idx)">
                        {{ $t('v2.change') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="$store.state.selected_type === 'DINE-IN'" class="item-checkout-option">
                    <v-switch v-model="item.is_takeaway" :ripple="false" dense hide-details class="mt-0 pt-0 switch-takeaway" @change="changeTakeaway" />
                    <div class="font-12 font-weight-400">
                      {{ $t('v2.takeaway') }}
                    </div>
                  </div>
                </div>
                <div class="list-line" />
              </div>
            </template>
          </div>
          <div class="list-item-checkout my-4">
            <v-textarea
              v-model="additional_form.notes"
              rows="3"
              :placeholder="$t(notePlaceholder)"
              outlined
              dense
              prepend-inner-icon="mdi-file-document-outline"
              hide-details
              class="input--notes"
            />
          </div>
          <div v-if="products_related.length > 0" class="container-product-related">
            <div class="px-3 font-weight-600 ol-black">
              {{ $t('v2.try_this_interesting_menu') }}
            </div>
            <slide-product :items="products_related" :click-detail="detailProductRelated" />
          </div>
          <div class="line-low my-4" />
          <div class="list-price" :style="{ marginBottom: heightFloating + 'px'}">
            <div class="title-list-price">
              {{ $t('v2.price') }}
            </div>
            <div class="list-component-price">
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.subtotal') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="nsubtotal" class="list-item-nominal-price" />
              </div>
              <div v-if="!$isEmpty(cart.discount_detail) && nvoucher > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.discount') }} ({{ cart.discount_detail.discount_code }})
                </div>
                <v-spacer />
                <div v-min-mask-money-only="nvoucher" class="list-item-nominal-price ol-accent" />
              </div>
              <div v-if="!$isEmpty(cart.point_detail) && cart.point_detail.type === 'D' && npoint > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.voucher_point') }}
                </div>
                <v-spacer />
                <div v-min-mask-money-only="npoint" class="list-item-nominal-price ol-accent" />
              </div>
              <div v-if="$store.state.selected_type === 'DELIVERY' && typeof shipping !== 'undefined' && !$isEmpty(shipping)" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.delivery_fee') }}
                </div>
                <v-spacer />
                <div v-if="nshipping_cost > 0" v-mask-money-only="nshipping_cost" class="list-item-nominal-price" />
                <div v-else class="list-item-nominal-price">
                  {{ $t('v2.free') }}
                </div>
              </div>
              <template v-if="$store.state.selected_type === 'OL-TAKE-AWAY' || $store.state.selected_type === 'DELIVERY'">
                <div v-if="nconvenience_fee > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.convenience_fee') }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="nconvenience_fee" class="list-item-nominal-price" />
                </div>
                <div v-if="((Number($store.state.selected_outlet.service_charge_rate) || Number($store.state.selected_outlet.service_charge_rate) > 0)) && nservice_charge > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.service_charge') }} ({{ Number($store.state.selected_outlet.service_charge_rate) * 100 }}%)
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="nservice_charge" class="list-item-nominal-price" />
                </div>
              </template>
              <template v-else>
                <div v-if="$store.state.selected_type === 'RESERVATION' && nconvenience_fee > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.convenience_fee') }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="nconvenience_fee" class="list-item-nominal-price" />
                </div>
                <div v-if="(Number($store.state.selected_outlet.service_charge_rate) || Number($store.state.selected_outlet.service_charge_rate) > 0) && nservice_charge > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.service_charge') }} ({{ Number($store.state.selected_outlet.service_charge_rate) * 100 }}%)
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="nservice_charge" class="list-item-nominal-price" />
                </div>
              </template>
              <template v-if="$store.state.selected_type === 'OL-TAKE-AWAY' || $store.state.selected_type === 'DELIVERY'">
                <div v-if="ntax > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }} ({{ Number($store.state.selected_outlet.tax_rate) * 100 + '%' }}) {{ $store.state.selected_outlet.price_tax_included ? '(' + $t('v2.price_includes_tax') + ')' : '' }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="ntax" class="list-item-nominal-price" />
                  <!-- <div v-else class="list-item-nominal-price">
                    -
                  </div> -->
                </div>
              </template>
              <template v-else>
                <div v-if="Number($store.state.selected_outlet.tax_rate) !== 0 && ntax > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }} ({{ Number($store.state.selected_outlet.tax_rate) * 100 + '%' }}) {{ $store.state.selected_outlet.price_tax_included ? '(' + $t('v2.price_includes_tax') + ')' : '' }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="ntax" class="list-item-nominal-price" />
                  <!-- <div v-else class="list-item-nominal-price">
                    -
                  </div> -->
                </div>
              </template>
              <div v-if="!$isEmpty(data_rounding) && data_rounding.is_rounded && data_rounding.data.rounded_amount !== 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="data_rounding.data.rounded_amount" :class="['list-item-nominal-price', { 'ol-accent': Number(data_rounding.data.rounded_amount) < 0 }]" />
              </div>
            </div>
            <div class="line-dot my-4" />
            <div class="total-price">
              <div class="total-price-title">
                {{ $t('v2.total') }}
              </div>
              <v-spacer />
              <div v-mask-money-only="ntotal" class="total-nominal-price" />
            </div>
            <template v-if="notSystem && possible_points > 0">
              <div class="line-dot my-6" />
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.point_earned') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  +{{ Number(possible_points) }} pts
                </div>
              </div>
            </template>
          </div>
          <div ref="section_floating" class="section-bottom white ol-min-elevation-2">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                  <div class="mb-4">
                    <div v-if="!$isEmpty(cart.discount_detail)" :class="[`flex-image btn-voucher pa-2`, { 'btn-voucher-warning': typeof cart.discount_voucher_id === 'undefined' }]" @click="showSelectedDiscount(cart.discount_detail.discount_id)">
                      <div class="flex-image-avatar mr-4">
                        <img v-if="(typeof cart.discount_voucher_id !== 'undefined')" src="@/assets/images/v2/img/icon_voucher2.png" alt="Voucher">
                        <img v-else src="@/assets/images/v2/img/icon_voucher3.png" alt="Voucher">
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text font-16 font-weight-600 ol-black">
                          {{ $t('v2.discount') }} <span v-mask-money="cart.discount_detail.discount_to_amount" />
                        </div>
                      </div>
                      <div>
                        <v-icon v-if="(typeof cart.discount_voucher_id !== 'undefined')" color="primary" size="22">
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="olorange" size="22" class="mr-1">
                          mdi-alert
                        </v-icon>
                      </div>
                    </div>
                    <div v-else class="flex-image btn-voucher pa-2" @click="showDiscount()">
                      <div class="flex-image-avatar mr-4">
                        <img src="@/assets/images/v2/img/icon_voucher.png" alt="Voucher">
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text font-16 ol-black">
                          {{ $t('v2.enter_voucher') }}
                        </div>
                      </div>
                      <div v-if="!$isEmpty(cart.discount_detail)">
                        <v-icon color="primary" size="22">
                          mdi-check-circle
                        </v-icon>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div v-if="!$isEmpty(cart.discount_detail) && typeof cart.discount_voucher_id !== 'undefined'" class="flex-image flex-image-center flex-potential-discount">
                      <div class="flex-image-avatar mr-1">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5643_24721)">
                            <path d="M15.2652 7.50803L11.3101 6.04403L9.83323 1.20358C9.77634 1.01692 9.60345 0.888916 9.40834 0.888916C9.21323 0.888916 9.04034 1.01692 8.98345 1.20358L7.50701 6.04403L3.55145 7.50803C3.37679 7.57292 3.26123 7.73869 3.26123 7.92492C3.26123 8.11069 3.37679 8.27736 3.55145 8.3418L7.50479 9.80536L8.98212 14.7934C9.03812 14.9818 9.21145 15.1111 9.40834 15.1111C9.60479 15.1111 9.77856 14.9818 9.83456 14.7929L11.3119 9.80492L15.2657 8.34136C15.4395 8.27736 15.5555 8.11114 15.5555 7.92492C15.5555 7.73914 15.4395 7.57292 15.2652 7.50803Z" fill="#FFAC33" />
                            <path d="M6.37634 12.3973L5.34789 12.0168L4.94789 10.5502C4.89545 10.3564 4.71989 10.2222 4.51945 10.2222C4.319 10.2222 4.14345 10.3564 4.09056 10.5497L3.69056 12.0164L2.66256 12.3968C2.48789 12.4613 2.37234 12.628 2.37234 12.8137C2.37234 12.9995 2.48789 13.1662 2.66256 13.2306L3.68522 13.6097L4.08834 15.2195C4.13811 15.4168 4.31545 15.5555 4.51945 15.5555C4.72345 15.5555 4.90078 15.4168 4.95056 15.2191L5.35367 13.6093L6.37634 13.2302C6.551 13.1662 6.66656 12.9995 6.66656 12.8137C6.66656 12.628 6.551 12.4613 6.37634 12.3973ZM4.44834 2.76928L3.39767 2.3804L3.00834 1.32928C2.94389 1.15462 2.77767 1.03906 2.59145 1.03906C2.40567 1.03906 2.23945 1.15462 2.17456 1.32928L1.78567 2.3804L0.734558 2.76928C0.559891 2.83417 0.444336 3.0004 0.444336 3.18617C0.444336 3.37195 0.559891 3.53862 0.734558 3.60306L1.78567 3.99195L2.17456 5.04306C2.23945 5.21773 2.40567 5.33328 2.59145 5.33328C2.77722 5.33328 2.94345 5.21773 3.00834 5.04306L3.39722 3.99195L4.44834 3.60306C4.623 3.53817 4.73856 3.37195 4.73856 3.18617C4.73856 3.0004 4.623 2.83417 4.44834 2.76928Z" fill="#FFCC4D" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5643_24721">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text font-11 font-weight-400">
                          {{ $t('v2.congratulations_you_saved', { price: priceFormat(Number(cart.discount_detail.discount_to_amount)) }) }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="!$isEmpty(potential_discount)" class="flex-image flex-image-center flex-potential-discount">
                      <div class="flex-image-avatar mr-1">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.6392 6.956C14.5743 6.78222 14.4081 6.66667 14.2223 6.66667H8.85565L11.9512 0.648C12.0485 0.458667 11.9983 0.227111 11.8308 0.0955556C11.7499 0.0315556 11.6525 0 11.5556 0C11.4521 0 11.3485 0.0364444 11.2654 0.108L8.00009 2.928L1.48765 8.55244C1.3472 8.67378 1.29653 8.86978 1.36142 9.04356C1.42631 9.21733 1.59209 9.33333 1.77787 9.33333H7.14454L4.04898 15.352C3.95165 15.5413 4.00187 15.7729 4.16942 15.9044C4.25031 15.9684 4.34765 16 4.44453 16C4.54809 16 4.65165 15.9636 4.73476 15.892L8.00009 13.072L14.5125 7.44756C14.6534 7.32622 14.7036 7.13022 14.6392 6.956Z" fill="#FFAC33" />
                        </svg>
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text font-11 font-weight-400">
                          {{ potential_discount.remaining_amount_left > 0 ? $t('v2.potential_discount', { price: priceFormat(Number(potential_discount.remaining_amount_left)) }) : $t('v2.there_is_promotion_available_for_you') }} <span class="font-weight-bold font-12 olbrand--text cursor-pointer" @click="showSelectedDiscount(potential_discount.id)">{{ $t('v2.view_voucher') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-btn block color="primary" :disabled="checkDisabledCheckout" height="40" class="text-none br-5" @click="goToCheckPhone()">
                    {{ $t('v2.order') }} (<div v-mask-money="ntotal" />)
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <product v-if="detail_product.sheet" v-model="detail_product" is-edit :default-data="detail_product.default" :click-addcart="AddOrUpdateCart" :click-delete="deleteItemCart" :selected-idx-commodity="{selectedCommodity, combo_index}" @listcombo="openListCombo" />
    <list-combo v-model="selectedCommodity" :open.sync="sheet_list_combo" :commodity="list_commodity" />
    <alert v-model="dialog.user_old" :message="$t('v2.you_successfully_logged_in')" />
    <v-dialog v-model="dialog.user_new" max-width="350">
      <v-card class="br-10">
        <v-card-text class="pa-4">
          <div class="mt-4">
            <v-img src="@/assets/images/v2/img/success_register.png" width="166" height="166" class="mx-auto" />
          </div>
          <div class="text-center mt-6">
            <div class="font-18 font-weight-700 ol-black mb-1">
              {{ $t('v2.welcome_v2', { name: new_user }) }}
            </div>
            <div class="subtext mb-4">
              {{ $t('v2.enjoy_easy_transaction') }}
            </div>
          </div>
          <v-btn block large depressed color="olbrand" height="40" class="text-none br-8 white--text" @click="dialog.user_new = false">
            {{ $t('v2.next') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="dialog.voucher_detail" content-class="dialog-icon">
      <div class="position-relative">
        <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.voucher_detail = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <template v-if="!$isEmpty(voucher_detail)">
                <div class="py-2 mb-8">
                  <div class="mt-2 font-18 font-weight-700">
                    {{ voucher_detail.title }}
                  </div>
                  <div v-if="voucher_detail.fexpiry_date" class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.expire_on') }} {{ voucher_detail.fexpiry_date }}
                  </div>
                </div>
                <div class="pa-4 br-8 bg-grey" :style="{ marginBottom: typeof cart.discount_voucher_id === 'undefined' ? '150px' : '64px' }">
                  <div class="font-weight-600 mb-2">
                    {{ $t('v2.terms_and_conditions') }}
                  </div>
                  <div class="font-14" v-html="voucher_detail.discount_description" />
                </div>
                <div class="section-bottom absolute white ol-min-elevation-2">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                        <div v-if="!voucher_detail.can_use" class="mb-3">
                          <div class="flex-image pa-4 bg-orange-soft br-8">
                            <div class="mr-2">
                              <v-icon size="24" color="olorange">
                                mdi-alert-outline
                              </v-icon>
                            </div>
                            <div class="flex-image-content">
                              <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                                {{ $t('v2.voucher_does_not_meet_the_terms_and_conditions') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <v-btn v-if="!$isEmpty(cart.discount_detail)" block color="white" height="40" class="text-none br-5 letter-spacing-normal font-weight-700 ol-red ol-elevation-1" @click="deleteVoucher(voucher_detail.id)">
                          {{ $t('v2.delete_voucher') }}
                        </v-btn>
                        <v-btn v-else block color="primary" :disabled="!voucher_detail.can_use" height="40" class="text-none br-5 letter-spacing-normal font-weight-700" @click="hitVoucher(voucher_detail.id, 1)">
                          {{ $t('v2.use_voucher') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="dialog.point_possible" content-class="dialog-icon">
      <div class="position-relative">
        <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.point_possible = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="py-2 mb-8">
                <div class="mt-2 font-18 font-weight-700">
                  {{ $t('v2.redeem_points') }}
                </div>
                <div class="font-12 font-weight-400 ol-grey-content">
                  {{ $t('v2.redeem_points_promo') }}
                </div>
              </div>
              <div class="pa-4 br-8 bg-grey" :style="{ marginBottom: '64px' }">
                <div class="font-weight-600 mb-2">
                  {{ $t('v2.terms_and_conditions') }}
                </div>
                <div class="font-14">
                  <ol>
                    <li v-for="(rule, index) in $t('v2.bonus_rules')" :key="index" v-html="rule" />
                  </ol>
                </div>
              </div>
              <!-- <div class="section-bottom absolute white ol-min-elevation-2">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                      <div v-if="!voucher_detail.can_use" class="mb-3">
                        <div class="flex-image pa-4 bg-orange-soft br-8">
                          <div class="mr-2">
                            <v-icon size="24" color="olorange">
                              mdi-alert-outline
                            </v-icon>
                          </div>
                          <div class="flex-image-content">
                            <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                              {{ $t('v2.voucher_does_not_meet_the_terms_and_conditions') }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-btn v-if="!$isEmpty(cart.discount_detail)" block color="white" height="40" class="text-none br-5 letter-spacing-normal font-weight-700 ol-red ol-elevation-1" @click="deleteVoucher(voucher_detail.id)">
                        {{ $t('v2.delete_voucher') }}
                      </v-btn>
                      <v-btn v-else block color="primary" :disabled="!voucher_detail.can_use" height="40" class="text-none br-5 letter-spacing-normal font-weight-700" @click="hitVoucher(voucher_detail.id)">
                        {{ $t('v2.use_voucher') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div> -->
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getDetail as getDetailProduct,
  getDetailCombo as getDetailProductCombo,
  getProductRelated
} from '@/api/product'
import { refreshCartMaterials } from '@/utils/helper'
import {
  getDataDetailValidate as getDiscountDetail
} from '@/api/discount'
import {
  getData as getCustomer
} from '@/api/customer'
import {
  calculatePoint
} from '@/api/point'
import {
  hitDiscount as hitDataDiscount,
  hitPotentialDiscount as hitDataPotentialDiscount
} from '@/api/discount'
import {
  createOrder,
  getDataShippingV2
} from '@/api/order'
import {
  checkRounding,
  delieverytimes as getDelieveryTimes
} from '@/api/setting'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import Product from '@/components/v2/product/Product'
import ListCombo from '@/components/v2/product/ListCombo'
import SlideProduct from '@/components/v2/product/SlideProduct'
import Alert from '@/components/v2/Alert'
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Product,
    ListCombo,
    SlideProduct,
    Alert
  },
  data() {
    return {
      data_rounding: {},
      voucher_detail: {},
      customer: {},
      top_menu: 0,
      dialog: {
        user_old: false,
        user_new: false,
        voucher_detail: false,
        point_possible: false
      },
      params: {
        remark: ''
      },
      new_user: '',
      detail_product: {
        type: 'product',
        sheet: false,
        item: {},
        method: 'add',
        default: {},
        key: null
      },
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      icon_take_away: require('@/assets/images/v2/img/icon_take_away.png'),
      cart: {},
      detail_table: {},
      detail_reservation: {},
      nsubtotal: 0,
      nvoucher: 0,
      npoint: 0,
      nshipping_cost: 0,
      nconvenience_fee: 0,
      nservice_charge: 0,
      ntax: 0,
      ntotal: 0,
      possible_points: 0,
      products_related: [],
      locations: {},
      shipping: {},
      delivery: {
        address: '',
        image: require('@/assets/images/v2/img/icon_truck.png'),
        delivery_method: ''
      },
      potential_discount: {},
      additional_form: {
        notes: ''
      },
      sheet_list_combo: false,
      list_commodity: [],
      selectedCommodity: [],
      combo_index: null
    }
  },
  computed: {
    ...mapGetters(['notSystem']),
    notePlaceholder() {
      return this.$store.state.selected_type === 'DELIVERY'
        ? 'v2.add_note_for_driver'
        : 'v2.add_note_order'
    },
    formatReserveDate() {
      return this.$formatDate(this.detail_reservation.reserve_date, true)
    },
    noTable() {
      if (!this.$isEmpty(this.detail_table) && !this.$isEmpty(this.detail_table.table_detail) && this.detail_table.table_detail.name) {
        return this.detail_table.table_detail.name
      } else {
        return ''
      }
    },
    heightFloating() {
      return this.top_menu
    },
    dataParamsPotential() {
      var params = {}
      params.remark = this.$store.state.selected_type
      return params
    },
    addressFilled() {
      const LOCAL_DATA_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
      if (LOCAL_DATA_LOCATION) {
        const locations = JSON.parse(LOCAL_DATA_LOCATION)
        if (typeof locations.name !== 'undefined' && typeof locations.shipping_address !== 'undefined' && typeof locations.shipping_lat !== 'undefined' && typeof locations.shipping_lon !== 'undefined' && typeof locations.shipping_radius !== 'undefined') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    checkDisabledCheckout() {
      if (this.$store.state.selected_type === 'RESERVATION') {
        if (this.detail_reservation && !this.$isEmpty(this.detail_reservation)) {
          return false
        } else {
          return true
        }
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.shipping && !this.$isEmpty(this.shipping)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mounted() {
    if (this.$store.state.selected_type === 'RESERVATION') {
      const DETAIL_RESERVATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation')
      if (DETAIL_RESERVATION) {
        const detail_reservation = JSON.parse(DETAIL_RESERVATION)
        this.detail_reservation = detail_reservation
      }
    }
    // this.top_menu = this.$refs.section_floating.clientHeight
    this.top_menu = 162
    const query = this.$route.query
    if (!this.$isEmpty(query)) {
      if (typeof query.user_type !== 'undefined') {
        if (query.user_type === 'new') {
          if (typeof query.user_name !== 'undefined') {
            this.new_user = query.user_name
          }
          this.dialog.user_new = true
        } else if (query.user_type === 'old') {
          this.dialog.user_old = true
        }
      }
    }
    this.calculation()
    if (this.notSystem) {
      this.getDataCustomer()
    }
    this.getListProductRelated()
  },
  methods: {
    priceFormat(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    detailUpSellingPoint() {
      this.dialog.point_possible = true
    },
    validReservation() {
      const reserve_now = new Date().getTime()
      const reserve_date = new Date(this.detail_reservation.reserve_date + ' ' + this.detail_reservation.reserve_time).getTime()
      if (reserve_now >= reserve_date) {
        this.detail_reservation = {}
        this.$store.dispatch('delDetailReservationV2')
      }
    },
    async checkCourierShipper() {
      try {
        const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
        var cart = {}
        if (LOCAL_DATA_CART) {
          cart = JSON.parse(LOCAL_DATA_CART)
        }
        const form = {
          shipping_lat: this.locations.shipping_lat,
          shipping_lon: this.locations.shipping_lon,
          item: cart.item
        }
        const { data } = await getDataShippingV2(form)
        const i = data.data.findIndex(async(item) => {
          item.rate_id === await this.shipping.shipping_courier_id
        })
        if (i !== -1) {
          this.shipping.shipping_cost = data.data[i].final_price
          this.shipping.shipping_courier_id = data.data[i].rate_id
          this.shipping.shipping_logo = data.data[i].image_url
          this.shipping.shipping_courier_name = data.data[i].logistic_name
          this.$store.dispatch('saveShippingV2', this.shipping)
          this.delivery.delivery_method = this.shipping.shipping_courier_name
          this.delivery.image = this.shipping.shipping_logo
        } else {
          this.shipping = {}
          await this.$store.dispatch('delShippingV2')
          this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
          this.delivery.delivery_method = ''
        }
      } catch (e) {
        this.shipping = {}
        await this.$store.dispatch('delShippingV2')
        this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
        this.delivery.delivery_method = ''
      }
    },
    async checkTimeCourier() {
      const today = new Date()
      const curDay = today.getDay() + 1
      try {
        const { data } = await getDelieveryTimes(curDay)
        if (!data.data.enabled) {
          this.shipping = {}
          this.$store.dispatch('delShippingV2')
          this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
          this.delivery.delivery_method = ''
        } else {
          const delivery_time = data.data.times
          const index = delivery_time.findIndex((item) => {
            const arrTime1 = item.ftime.split('')
            const arrTime2 = this.shipping.shipping_time.split('')
            if (arrTime1[0] === arrTime2[0] && arrTime1[1] === arrTime2[1] && arrTime1[2] === arrTime2[2] && arrTime1[3] === arrTime2[3] && arrTime1[4] === arrTime2[4]) {
              this.delivery.delivery_method = this.$t('v2.restaurant_courier') + ' (' + this.shipping.shipping_time + ')'
              return true
            } else {
              return false
            }
          })

          if (index !== -1) {
            if (this.$store.state.selected_store.delivery.unlimited_items_order === 0) {
              if (delivery_time[index].order_left === 0 || delivery_time[index].time_has_passed === 1) {
                this.shipping = {}
                this.$store.dispatch('delShippingV2')
                this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
                this.delivery.delivery_method = ''
              }
            } else {
              if (delivery_time[index].time_has_passed === 1) {
                this.shipping = {}
                this.$store.dispatch('delShippingV2')
                this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
                this.delivery.delivery_method = ''
              }
            }
          } else {
            this.shipping = {}
            this.$store.dispatch('delShippingV2')
            this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
            this.delivery.delivery_method = ''
          }
        }
      } catch (e) {
        this.shipping = {}
        this.$store.dispatch('delShippingV2')
        this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
        this.delivery.delivery_method = ''
      }
    },
    async deletePoint() {
      if (this.cart.point_detail.type === 'P') {
        var i = 0
        while (i < this.cart.item.length) {
          if (typeof this.cart.item[i].product_type !== 'undefined' && this.cart.item[i].product_type === 'point') {
            this.cart.item.splice(i, 1)
          } else {
            ++i
          }
        }
      }
      this.$delete(this.cart, 'requestId')
      this.$delete(this.cart, 'redeemId')
      this.$delete(this.cart, 'point_detail')
      await this.$store.dispatch('saveCartV2', this.cart)
      this.calculation()
    },
    showPoint() {
      this.$router.push({ name: '_points' }).catch(() => {})
    },
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
      } catch (e) {
        this.customer = {}
      }
    },
    async calcPoint() {
      try {
        const { data } = await calculatePoint(this.cart)
        this.possible_points = data.accumulated_possible_points
      } catch (e) {
        console.log(e)
      }
    },
    async calculation() {
      if (this.$store.state.selected_type === 'DINE-IN') {
        const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
        if (DETAIL_TABLE) {
          this.detail_table = JSON.parse(DETAIL_TABLE)
        }
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        this.validReservation()
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        const LOCAL_DATA_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
        if (LOCAL_DATA_LOCATION) {
          this.locations = JSON.parse(LOCAL_DATA_LOCATION)
          if (typeof this.locations.name !== 'undefined' && typeof this.locations.shipping_address !== 'undefined' && typeof this.locations.shipping_lat !== 'undefined' && typeof this.locations.shipping_lon !== 'undefined' && typeof this.locations.shipping_radius !== 'undefined') {
            this.delivery.address = this.locations.name + ' - ' + this.locations.shipping_address

            const LOCAL_DATA_SHIPPING = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
            if (LOCAL_DATA_SHIPPING) {
              this.shipping = JSON.parse(LOCAL_DATA_SHIPPING)
              if (typeof this.shipping.shipping_courier_name !== 'undefined') {
                if (this.shipping.shipping_delivery_type === 1) {
                  await this.checkTimeCourier()
                } else if (this.shipping.shipping_delivery_type === 2) {
                  await this.checkCourierShipper()
                }
              }
            }
          } else {
            this.shipping = {}
            this.$store.dispatch('delShippingV2')
            this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
            this.delivery.delivery_method = ''
          }
        } else {
          this.shipping = {}
          this.$store.dispatch('delShippingV2')
          this.delivery.image = require('@/assets/images/v2/img/icon_truck.png')
          this.delivery.delivery_method = ''
        }
      }
      const LOCAL_DATA_ADDITIONAL = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_additional')
      if (LOCAL_DATA_ADDITIONAL) {
        this.additional_form = JSON.parse(LOCAL_DATA_ADDITIONAL)
      }
      const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
      if (LOCAL_DATA_CART) {
        this.cart = JSON.parse(LOCAL_DATA_CART)
        await refreshCartMaterials(this.cart)
        localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart', JSON.stringify(this.cart))
        if (!this.$isEmpty(this.cart.discount_detail)) {
          await this.hitVoucher(this.cart.discount_detail.discount_id)
        }
        await this.hitPotentialVoucher()
        var item_price = []
        var item_tax = []
        var item_service = []
        if (this.cart.item) {
          for (const i in this.cart.item) {
            if (typeof this.cart.item[i].product_type === 'undefined' || this.cart.item[i].product_type !== 'point') {
              if (this.cart.item[i].non_taxable === 0) {
                item_tax[i] = this.cart.item[i].sub_total
              }
              if (this.cart.item[i].non_service_charge === 0) {
                item_service[i] = this.cart.item[i].sub_total
              }
              item_price[i] = this.cart.item[i].sub_total
            }
          }
        }
        await this.sumPrice(item_price, item_tax, item_service)
        if (typeof this.cart.item === 'undefined' || this.cart.item.length === 0) {
          this.goBack()
        }
        if (this.notSystem && typeof this.cart.item !== 'undefined' && this.cart.item.length > 0 && typeof this.cart.redeemId === 'undefined') {
          this.calcPoint()
        } else {
          this.possible_points = 0
        }
      }
    },
    async deleteVoucher() {
      this.voucher_detail = {}
      this.dialog.voucher_detail = false
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      await this.$store.dispatch('saveCartV2', this.cart)
      this.calculation()
    },
    async showSelectedDiscount(id) {
      this.voucher_detail = {}
      const data_hit = { ...this.cart }
      data_hit.remark = this.$store.state.selected_type
      try {
        const { data } = await getDiscountDetail(id, data_hit)
        this.dialog.voucher_detail = true
        this.voucher_detail = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goBack() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    },
    showDiscount() {
      this.$router.push({ name: '_vouchers' }).catch(() => {})
    },
    async goToCheckPhone() {
      this.cart.total_pay = this.ntotal
      await this.$store.dispatch('saveCartV2', this.cart)
      await this.$store.dispatch('saveAdditionalV2', this.additional_form)
      // this.calculation()
      if (this.$store.state.selected_type === 'RESERVATION') {
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.$store.dispatch('saveDetailReservationV2', this.detail_reservation)
          const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
          if (auth_data !== null) {
            if (auth_data.auth_by === 'BASIC' || auth_data.auth_by === 'GUEST') {
              if (this.cart.total_pay === 0) {
                this.handleCheckoutFree()
              } else {
                this.$router.push({ name: '_payment' }).catch(() => {})
              }
            } else {
              this.$router.push({ name: '_phone_check', query: { redirect: this.$route.name }}).catch(() => {})
            }
          } else {
            if (this.cart.total_pay === 0) {
              this.handleCheckoutFree()
            } else {
              this.$router.push({ name: '_payment' }).catch(() => {})
            }
          }
        }
      } else {
        const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
        if (auth_data !== null) {
          if (auth_data.auth_by === 'BASIC' || auth_data.auth_by === 'GUEST') {
            if (this.cart.total_pay === 0) {
              this.handleCheckoutFree()
            } else {
              this.$router.push({ name: '_payment' }).catch(() => {})
            }
          } else {
            this.$router.push({ name: '_phone_check', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else {
          if (this.cart.total_pay === 0) {
            this.handleCheckoutFree()
          } else {
            this.$router.push({ name: '_payment' }).catch(() => {})
          }
        }
      }
    },
    async detailProductCombo(item, idx) {
      try {
        const { data } = await getDetailProductCombo(item.product_combo_id)
        this.detail_product.type = 'product_combo'
        this.detail_product.sheet = true
        this.detail_product.item = data.data
        this.detail_product.method = 'update'
        this.detail_product.default = item
        this.detail_product.key = idx
        document.querySelector('html').style.overflowY = 'hidden'
      } catch (e) {
        console.log(e)
      }
    },
    async detailProduct(item, idx) {
      try {
        const { data } = await getDetailProduct(item.product_id)
        this.detail_product.type = 'product'
        this.detail_product.sheet = true
        this.detail_product.item = data.data
        this.detail_product.method = 'update'
        this.detail_product.default = item
        this.detail_product.key = idx
        document.querySelector('html').style.overflowY = 'hidden'
      } catch (e) {
        console.log(e)
      }
    },
    async detailProductRelated(item) {
      try {
        const { data } = await getDetailProduct(item.id)
        this.detail_product.type = 'product'
        this.detail_product.sheet = true
        this.detail_product.item = data.data
        this.detail_product.method = 'add'
        document.querySelector('html').style.overflowY = 'hidden'
      } catch (e) {
        console.log(e)
      }
    },
    getCartItemIdentity(item) {
      const addonsKey = (item.addons || [])
        .map(a => `${a.product_addon_id}-${a.product_addon_variant_id || ''}`)
        .sort()
        .join(',')
      const comboItemsKey = (item.product_combo_items || [])
        .map(c => `${c.id}-${c.children_id || ''}-${c.variant_id || ''}`)
        .sort()
        .join(',')
      return [
        item.product_id,
        item.product_combo_id,
        item.product_variant_id,
        item.note || '',
        addonsKey,
        comboItemsKey
      ].join('|')
    },
    async AddOrUpdateCart(form, type, method) {
      if (method === 'update') {
        this.cart.item[this.detail_product.key] = form
        await this.$store.dispatch('saveCartV2', this.cart)
        this.calculation()
      } else {
        const index = this.cart.item.findIndex((e) => {
          if (typeof e.product_type !== 'undefined' && e.product_type === 'point') {
            return false
          }
          return this.getCartItemIdentity(e) === this.getCartItemIdentity(form)
        })

        if (index === -1) {
          await this.cart.item.push({ ...form })
        } else {
          this.cart.item[index].qty = await this.cart.item[index].qty + form.qty
          this.cart.item[index].sub_total = await this.cart.item[index].sub_total + form.sub_total
        }
        await this.$store.dispatch('saveCartV2', this.cart)
        this.calculation()
        this.getListProductRelated()
      }
    },
    syncCartToStorage(_storage) {
      const key = process.env.VUE_APP_COOKIE_KEY + _storage
      localStorage.setItem(key, JSON.stringify(this.cart))
    },
    async deleteItemCart() {
      const idx = this.detail_product.key
      if (idx < 0 || !(this.cart && this.cart.item && this.cart.item.length)) return

      const item = this.cart.item[idx]

      const isCombo = item.product_combo_id !== null && item.product_combo_id !== undefined
      const productId = isCombo ? item.product_combo_id : item.product_id

      const min = Number(item.min_order || 0)
      const max = Number(item.max_order || 0)
      const _storage = '_v2_cart'

      this.syncCartToStorage(_storage)

      const result = this.$canOrder(
        productId,
        0,
        min,
        max,
        _storage,
        'edit',
        idx
      )

      if (!result.valid && result.flag === 'BELOW_MIN') {
        this.cart.item = this.cart.item.filter(function(i) {
          const compareId = isCombo
            ? i.product_combo_id
            : i.product_id

          return Number(compareId) !== Number(productId)
        })
      } else {
        this.cart.item.splice(idx, 1)
      }

      if (this.cart.point_detail && this.cart.point_detail.type === 'P') {
        let stillItem = false
        for (let i = 0; i < this.cart.item.length; i++) {
          const it = this.cart.item[i]
          if (!it.product_type || it.product_type !== 'point') {
            stillItem = true
            break
          }
        }
        if (!stillItem) {
          this.cart.item = []
        }
      }

      if (!this.cart.item.length) {
        this.$delete(this.cart, 'requestId')
        this.$delete(this.cart, 'redeemId')
        this.$delete(this.cart, 'point_detail')
        this.$delete(this.cart, 'discount_voucher_id')
        this.$delete(this.cart, 'discount_detail')
      } else {
        if (!this.$isEmpty(this.cart.discount_detail)) {
          await this.hitVoucher(this.cart.discount_detail.discount_id)
        }
      }

      await this.$store.dispatch('saveCartV2', this.cart)
      this.calculation()
      this.getListProductRelated()
    },
    textAddons(item) {
      if (item.product_combo_id) {
        const arr = []
        for (let i = 0; i < item.product_combo_items.length; i++) {
          arr.push(item.product_combo_items[i].name)
        }
        return arr.join(', ')
      } else {
        if (typeof item.addons !== 'undefined' && item.addons.length !== 0) {
          const names = item.addons.map(function(item) {
            return item['product_addon_name']
          })
          return names.join(', ')
        } else {
          return ''
        }
      }
    },
    async sumPrice(obj, objTax, objService) {
      var sum = 0
      for (var el in obj) {
        if (obj.hasOwnProperty(el)) {
          sum += parseFloat(obj[el])
        }
      }

      var sumService = 0
      for (var serviceEl in objService) {
        if (objService.hasOwnProperty(serviceEl)) {
          sumService += parseFloat(objService[serviceEl])
        }
      }

      var sumTax = 0
      for (var taxEl in objTax) {
        if (objTax.hasOwnProperty(taxEl)) {
          sumTax += parseFloat(objTax[taxEl])
        }
      }

      this.nsubtotal = sum
      this.ntotal = this.nsubtotal

      if (typeof this.cart.discount_voucher_id !== 'undefined' && typeof this.cart.discount_detail !== 'undefined' && !this.$isEmpty(this.cart.discount_detail)) {
        this.nvoucher = this.ntotal < Number(this.cart.discount_detail.discount_to_amount) ? this.ntotal : Number(this.cart.discount_detail.discount_to_amount)
        this.ntotal = this.ntotal - this.nvoucher
      } else {
        this.nvoucher = 0
        this.ntotal = this.ntotal
      }

      if (typeof this.cart.point_detail !== 'undefined' && !this.$isEmpty(this.cart.point_detail) && this.cart.point_detail.type === 'D') {
        if (Number(this.cart.point_detail.discount_amount) === 0) {
          this.npoint = ((this.ntotal * Number(this.cart.point_detail.discount_rate)) / 100) > Number(this.cart.point_detail.max_discount_amount) && Number(this.cart.point_detail.max_discount_amount) !== 0 ? Number(this.cart.point_detail.max_discount_amount) : (this.ntotal * Number(this.cart.point_detail.discount_rate)) / 100
        } else {
          this.npoint = Number(this.cart.point_detail.discount_amount)
        }
        this.npoint = this.ntotal < this.npoint ? this.ntotal : this.npoint
        this.ntotal = this.ntotal - this.npoint
      } else {
        this.npoint = 0
        this.ntotal = this.ntotal - this.npoint
      }

      let trans_fee = 0
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        trans_fee = Number(this.$store.state.selected_outlet.setting.trans_fee_rate_takeaway)
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        trans_fee = Number(this.$store.state.selected_outlet.setting.trans_fee_rate_delivery)
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        trans_fee = Number(this.$store.state.selected_outlet.setting.trans_fee_rate)
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        trans_fee = Number(this.$store.state.selected_outlet.setting.trans_fee_rate_reservation)
      }

      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        // this.nconvenience_fee = Math.round(this.ntotal * 1) / 100
        if (trans_fee > 0) {
          this.nconvenience_fee = (Math.round(this.ntotal * trans_fee)) < 500 ? 500 : (Math.round(this.ntotal * trans_fee))
        }
        this.ntotal = this.ntotal + this.nconvenience_fee
        if (this.$store.state.selected_outlet.pos_take_away_with_service_charge && !this.$store.state.selected_outlet.price_service_charge_included) {
          const value = Math.max(0, sumService - (this.$store.state.selected_outlet.pos_tax_before_discount ? 0 : (this.nvoucher + this.npoint)))
          this.nservice_charge = Math.round((value * Number(this.$store.state.selected_outlet.service_charge_rate)) * 100) / 100
          this.ntotal = this.ntotal + this.nservice_charge
        }
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        // this.nconvenience_fee = Math.round(this.ntotal * 1) / 100
        if (trans_fee > 0) {
          this.nconvenience_fee = (Math.round(this.ntotal * trans_fee)) < 500 ? 500 : (Math.round(this.ntotal * trans_fee))
        }
        this.ntotal = this.ntotal + this.nconvenience_fee
        if (this.$store.state.selected_outlet.pos_food_delivery_with_service_charge && !this.$store.state.selected_outlet.price_service_charge_included) {
          const value = Math.max(0, sumService - (this.$store.state.selected_outlet.pos_tax_before_discount ? 0 : (this.nvoucher + this.npoint)))
          this.nservice_charge = Math.round((value * Number(this.$store.state.selected_outlet.service_charge_rate)) * 100) / 100
          this.ntotal = this.ntotal + this.nservice_charge
        }
      } else {
        if (this.$store.state.selected_type === 'RESERVATION') {
          if (trans_fee > 0) {
            this.nconvenience_fee = (Math.round(this.ntotal * trans_fee)) < 500 ? 500 : (Math.round(this.ntotal * trans_fee))
          }
          this.ntotal = this.ntotal + this.nconvenience_fee
        }
        if (!this.$store.state.selected_outlet.price_service_charge_included) {
          const value = Math.max(0, sumService - (this.$store.state.selected_outlet.pos_tax_before_discount ? 0 : (this.nvoucher + this.npoint)))
          this.nservice_charge = Math.round((value * Number(this.$store.state.selected_outlet.service_charge_rate)) * 100) / 100
          this.ntotal = this.ntotal + this.nservice_charge
        }
      }

      if (this.$store.state.selected_outlet.pos_tax_before_discount) {
        if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          if (this.$store.state.selected_outlet.pos_take_away_no_tax !== 1) {
            if (this.$store.state.selected_outlet.price_tax_included) {
              // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
              // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
              const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
              this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
            } else {
              const value = Math.max(0, sumTax)
              this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
            }
          }
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          if (this.$store.state.selected_outlet.pos_food_delivery_with_tax) {
            if (this.$store.state.selected_outlet.price_tax_included) {
              // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
              // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
              const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
              this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
            } else {
              const value = Math.max(0, sumTax)
              this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
            }
          }
        } else {
          if (this.$store.state.selected_outlet.price_tax_included) {
            // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
            // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
            const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
            this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
          } else {
            const value = Math.max(0, sumTax)
            this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
          }
        }
      } else {
        if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          if (this.$store.state.selected_outlet.pos_take_away_no_tax !== 1) {
            const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
            if (this.$store.state.selected_outlet.price_tax_included) {
              // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
              // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
              this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
            } else {
              this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
            }
          }
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          if (this.$store.state.selected_outlet.pos_food_delivery_with_tax) {
            if (this.$store.state.selected_outlet.price_tax_included) {
              // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
              // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
              const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
              this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
            } else {
              const value = Math.max(0, sumTax)
              this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
            }
          }
        } else {
          const value = Math.max(0, sumTax - this.nvoucher - this.npoint)
          if (this.$store.state.selected_outlet.price_tax_included) {
            // request dari ko law pukul 15.02 tanggal 28-02-2023 (karena POS, kalau transaksi termasuk pajak service charge nya tidak di hitung)
            // update tanggal 28 Feb 2024, chat dari ko law 15.31 samakan perhitungan dengan backoffice, ko law info untuk tax_before_discount === 1 tetap samakan dengan tax_before_discount === 0. ntr ribet ganti backoffice lagi
            this.ntax = Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) - (Math.round(value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) / (1 + Number(this.$store.state.selected_outlet.tax_rate)))
          } else {
            this.ntax = Math.round(((value + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.nservice_charge)) * Number(this.$store.state.selected_outlet.tax_rate)) * 100) / 100
          }
        }
      }

      if (Number(this.$store.state.selected_outlet.tax_rate) !== 0 && !this.$store.state.selected_outlet.price_tax_included) {
        this.ntotal = this.ntotal + this.ntax
      }

      if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.shipping.shipping_delivery_type === 1) {
          if (this.nsubtotal < Number(this.$store.state.selected_outlet.delivery.minimum_order)) {
            this.nshipping_cost = this.locations.shipping_radius * Number(this.$store.state.selected_outlet.delivery.cost_outside_radius)
          } else {
            if (this.locations.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.nshipping_cost = (this.locations.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
            } else {
              this.nshipping_cost = 0
            }
          }
        } else if (this.shipping.shipping_delivery_type === 2) {
          this.nshipping_cost = Number(this.shipping.shipping_cost)
        } else {
          this.nshipping_cost = 0
        }
        this.ntotal = this.ntotal + this.nshipping_cost
      }

      this.CheckRound(this.ntotal)
      // if (this.$store.state.selected_type === 'RESERVATION' && !this.$isEmpty(this.$store.state.selected_outlet)) {
      //   if (this.$store.state.selected_outlet.reservation.reservation_payment_terms === 2) {
      //     if (this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount_type === 0) {
      //       this.totalDownPaynent = Number(this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount) + this.totalConvenienceFee
      //     } else {
      //       this.totalDownPaynent = ((this.totalPrice * Number(this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount)) / 100) + this.totalConvenienceFee
      //     }
      //   } else if (this.$store.state.selected_outlet.reservation.reservation_payment_terms === 3) {
      //     this.totalDownPaynent = this.totalConvenienceFee
      //   }
      // }
    },
    async changeTakeaway() {
      await this.$store.dispatch('saveCartV2', this.cart)
      this.calculation()
    },
    async hitVoucher(id, skip_hit_voucher = 0) {
      const data_hit = { ...this.cart }
      data_hit.discount_id = id
      data_hit.remark = this.$store.state.selected_type
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      try {
        const { data } = await hitDataDiscount(data_hit)
        this.cart.discount_voucher_id = id
        this.$set(this.cart, 'discount_voucher_id', id)
        this.$set(this.cart, 'discount_detail', data.data)
        await this.$store.dispatch('saveCartV2', this.cart)
        if (this.dialog.voucher_detail) {
          this.dialog.voucher_detail = false
        }
        if (skip_hit_voucher) {
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.discount_successfully_used')
          this.$store.state.error_type = 200
          this.calculation()
        }
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
        if (!this.$isEmpty(data_hit.discount_detail)) {
          this.$delete(this.cart, 'discount_voucher_id')
          this.$set(this.cart, 'discount_detail', data_hit.discount_detail)
          await this.$store.dispatch('saveCartV2', this.cart)
        }
      }
    },
    async handleCheckoutFree() {
      if (this.$store.state.selected_type !== 'DELIVERY') {
        delete this.cart.shipping_address
        delete this.cart.shipping_cost
      }
      if (this.$store.state.selected_type === 'DINE-IN') {
        const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
        if (DETAIL_TABLE) {
          const detail_table = JSON.parse(DETAIL_TABLE)
          this.cart.total_guest = detail_table.total_guest
          this.cart.table = detail_table.table
        }
      }
      if (this.$store.state.selected_type === 'RESERVATION') {
        const DETAIL_RESERVATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation')
        if (DETAIL_RESERVATION) {
          const detail_reservation = JSON.parse(DETAIL_RESERVATION)
          this.cart.reserve_date = detail_reservation.reserve_date
          this.cart.reserve_time = detail_reservation.reserve_time
          this.cart.total_guest = detail_reservation.total_guest
          this.cart.email = detail_reservation.email
        }
      }
      if (this.$store.state.selected_type === 'DELIVERY') {
        const DETAIL_DELIVERY = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
        const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
        if (DETAIL_DELIVERY && DETAIL_LOCATION) {
          const detail_delivery = JSON.parse(DETAIL_DELIVERY)
          const detail_location = JSON.parse(DETAIL_LOCATION)
          this.cart.shipping_address = detail_location.name + ' -- ' + detail_location.shipping_address
          this.cart.shipping_cost = detail_delivery.shipping_cost
          this.cart.shipping_courier_id = detail_delivery.shipping_courier_id
          this.cart.shipping_courier_name = detail_delivery.shipping_courier_name
          this.cart.shipping_delivery_type = detail_delivery.shipping_delivery_type
          this.cart.shipping_time = detail_delivery.shipping_time
          this.cart.shipping_lat = detail_location.shipping_lat
          this.cart.shipping_lon = detail_location.shipping_lon
          this.cart.shipping_radius = detail_location.shipping_radius
        }
      }

      const selected_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type'))
      this.cart.remark = selected_type
      this.$set(this.cart, 'payment', {
        payment_mode_id: 10
      })
      this.cart.item.map(item => {
        if (item.is_takeaway) {
          item.note = 'TAKE AWAY, ' + item.note
        }
      })
      try {
        const { data } = await createOrder(this.cart)
        this.$store.dispatch('saveIdOrder', data.data.id)
        this.$store.dispatch('removeCartV2')
        if (this.$store.state.selected_type === 'DELIVERY') {
          const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
          if (DETAIL_LOCATION) {
            const old_detail_location = JSON.parse(DETAIL_LOCATION)
            const history = old_detail_location.history || []
            const new_detail_location = { ...old_detail_location }
            const newHash = await this.$hashLatLon(new_detail_location.shipping_lat, new_detail_location.shipping_lon)
            const existingHashes = await Promise.all(
              history.map(async item => await this.$hashLatLon(item.shipping_lat, item.shipping_lon))
            )
            if (!existingHashes.includes(newHash)) {
              delete old_detail_location.history
              history.unshift(old_detail_location) // masukkan di depan
              if (history.length > 5) history.pop() // buang yang paling lama di belakang
              new_detail_location.history = history
            }
            delete new_detail_location.name
            delete new_detail_location.driver_note
            delete new_detail_location.shipping_address
            delete new_detail_location.shipping_lat
            delete new_detail_location.shipping_lon
            delete new_detail_location.shipping_radius
            this.$store.dispatch('saveLocationV2', new_detail_location)
          }
        }

        if (this.$store.state.selected_type === 'RESERVATION') {
          this.$store.dispatch('delDetailReservationV2')
        }
        this.$router.push({ name: '_resp_order', params: { id: data.data.id }}).catch(() => {})
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          this.$router.push({ name: '_phone_check', query: { redirect: this.$route.name }}).catch(() => {})
        } else if (e.statusCode === 501) {
          if (!this.$isEmpty(this.cart)) {
            // if (this.$store.state.selected_type === 'DELIVERY') {
            //   this.dialogChangeShippingTime = true
            //   this.loadShippingTime()
            // }
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async getListProductRelated() {
      const form = {
        item: []
      }
      if (typeof this.cart.item !== 'undefined' && this.cart.item.length > 0) {
        this.cart.item.map(item => {
          if (item.note !== 'REDEEMED' && item.product_id) {
            form.item.push({
              product_id: item.product_id
            })
          }
        })
      }
      if (form.item.length > 0) {
        try {
          const { data } = await getProductRelated(form)
          this.products_related = data.recommendation
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    goToMapsSearch() {
      this.$router.push({ name: '_maps_search' }).catch(() => {})
    },
    goToDeliveryMethod() {
      if (this.addressFilled) {
        this.$router.push({ name: '_delivery_method' }).catch(() => {})
      } else {
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.fill_in_the_address_first')
        this.$store.state.error_type = 402
      }
    },
    updateReservation() {
      this.$router.push({ name: '_reservation_detail', query: { redirect: '_checkout' }}).catch(() => {})
    },
    async CheckRound(amount) {
      try {
        const data_payload = {
          total_amount: amount
        }
        const data = await checkRounding(data_payload)
        this.data_rounding = data.data
        this.ntotal = this.data_rounding.data.total_amount
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async hitPotentialVoucher() {
      const data_hit = { ...this.cart }
      try {
        const { data } = await hitDataPotentialDiscount(data_hit, this.dataParamsPotential)
        this.potential_discount = data.data
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.potential_discount = {}
          return false
        }
      }
    },
    openListCombo(data) {
      this.combo_index = data.index
      this.list_commodity = data.commodity
      this.selectedCommodity = data.selected
      this.sheet_list_combo = true
    }
  }
}
</script>
